import { render } from "./HelloWorld.vue?vue&type=template&id=ce6417b4&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ce6417b4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ce6417b4"

export default script